export const DateFormats = {
  DEFAULT: "D-MMM-YYYY",
};